import React, { useContext } from 'react';

import { AuthContext } from 'Auth/AuthContext';

import { moveLabels } from './moveTranslations';

import { labels } from './translations';

import formatRate from './formatRate';

import styles from './BillingCapacityDetails.module.scss';

import detailStyles from '../components/detailsModal/Details/Details.module.scss';

export default function BillingCapacityDetails({ summary, children }) {
  const { authState } = useContext(AuthContext) || {};
  const copy = labels[authState?.user?.language === 'ar' ? 'ar' : 'en'];
  const statusCopy = moveLabels[authState?.user?.language === 'ar' ? 'ar' : 'en'];
  const state =
    !summary || summary?.mode === 'legacy'
      ? 'legacy'
      : summary?.mode === 'setup_pending'
      ? 'setup'
      : summary?.qualification?.status === 'unqualified'
      ? 'unsupported'
      : summary?.mode === 'legacy_transition'
      ? 'transition'
      : 'supported';
  const values = [
    [copy.active, summary?.usage?.active],
    [copy.inactive, summary?.usage?.inactive],
    [copy.purchasedActive, summary?.purchased?.active],
    [copy.purchasedInactive, summary?.purchased?.inactive],
    [copy.activeRate, formatRate(summary?.activeRate)],
    [copy.inactiveRate, formatRate(summary?.inactiveRate)],
  ];
  return (
    <section
      dir={authState?.user?.language === 'ar' ? 'rtl' : 'ltr'}
      className={`${styles.card} border rounded p-3 my-3`}
      aria-label={copy.title}
    >
      <span className='fw-bold mt-1'>{copy.title}</span>
      {state !== 'supported' && (
        <p className='font-size-12 mt-3 mb-0' role='status'>
          {statusCopy[state]}
        </p>
      )}
      <dl className={`${styles.facts} d-flex flex-column gap-2 mt-4 mb-3`}>
        {values.map(([label, value], index) => (
          <div className={styles.row} key={label}>
            <dt className={`${detailStyles.label} mb-0`}>{label}</dt>
            <dd className={`${detailStyles.values} m-0`}>
              <bdi dir='ltr' style={{ direction: 'ltr', unicodeBidi: 'isolate' }}>
                {value == null
                  ? '—'
                  : `${value}${
                      index > 3
                        ? ` ${summary?.currency || ''}${
                            summary?.ratePeriod
                              ? ` / ${summary?.ratePeriod.count} ${copy[summary?.ratePeriod.unit]}`
                              : ''
                          }`
                        : ''
                    }`}
              </bdi>
            </dd>
          </div>
        ))}
      </dl>
      <p className='font-size-12 mb-0'>{copy.retained}</p>
      {children && <div className={`${styles.actions} mt-3`}>{children}</div>}
    </section>
  );
}
